module.exports = __webpack_public_path__ + "static/media/Icon-web-asset.c3c94ff4.svg";